import { useOutletContext } from "react-router-dom";
import useSWRImmutable from "swr/immutable";

const mkKey = (therapy, type) => {
  if (!therapy && !type) return "/items";

  const q = new URLSearchParams();
  if (therapy) q.set("therapy", therapy);
  if (type) q.set("type", type);

  return `/items?${q.toString()}`;
};

/**
 * @param {"cct" | "sam" | "gr" | null} [therapy = null]
 * @param {"consumable" | "serialized" | null} [type = null]
 */
export default function useItems(therapy = null, type = null) {
  const { api } = useOutletContext();
  return useSWRImmutable(mkKey(therapy, type), () =>
    api.itemList(therapy, type)
  );
}
